module.exports = __webpack_public_path__ + "static/media/2 (43).4be723dd.jpg";